<div class="url-dialog-container">
  <label for="url-input" class="url-label"> {{ 'eventForm.formFields.url' | translate }}</label>
  <input id="url-input" type="text" [formControl]="urlCtrl" class="url-input" />
  <div *ngIf="urlCtrl.invalid && urlCtrl.touched" class="error-text">
    {{ 'eventForm.validations.url' | translate }}
  </div>

  <div class="url-dialog-actions">
    <button mat-button (click)="cancel()">{{ 'snackbar.cancel' | translate }}</button>
    <button mat-flat-button color="primary" (click)="insert()" [disabled]="urlCtrl.invalid">
      {{ 'eventForm.labels.insert' | translate }}
    </button>
  </div>
</div>
